import React, { useEffect } from "react";
import totalPlayer from "./icon/total_player_icon.svg";
import total_bet_amount_icon from "./icon/total_bet_amount_icon.svg";
import total_win_amount_icon from "./icon/total_win_amount_icon.svg";
import total_add_amount_icon from "./icon/total_add_amount_icon.svg";
import total_withdraw_icon from "./icon/total_withdraw_icon.svg";
import total_income_icon from "./icon/total_income_icon.svg";
import games_icon from "./icon/games.svg";
import axios from "axios";
import CountUp from "react-countup";
import { API_URL } from "../src/config";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "./Lib/ContextLib";


const StatCard = ({ title, value, icon, trend, onClick, iconClass }) => {
  return (
    <div className="premium-dashboard-card" onClick={onClick}>
      <div className="card-header-row">
        <img src={icon} alt={title} className={`card-icon-small ${iconClass}`} />
        <h5 className="card-title-text">{title}</h5>
        {trend && <span className="card-trend-badge">{trend}</span>}
      </div>
      <div className="card-content-row">
        <h2 className="card-value-large">{value}</h2>
        <div className="card-mini-chart">
           <img src={icon} alt="chart" className={iconClass} />
        </div>
      </div>
    </div>
  );
};

export default function Dashboard() {
  const history = useNavigate();
  const {
                                    accessObject,
  } = useAppContext();
  const [totalPlayerData, setTotalPlayerData] = React.useState([]);
  const [totalBetAmountData, setTotalBetAmountData] = React.useState([]);
  const [totalWinAmountData, setTotalWinAmountData] = React.useState([]);
  const [totalIncome, setTotalIncome] = React.useState("");
  const [totalAddAmountData, setTotalAddAmountData] = React.useState([]);
  const [totalWithdrawAmountData, setTotalWithdrawAmountData] = React.useState(
    []
  );
  const [pendingAddAmountData, setPendingAddAmountData] = React.useState([]);
  const [pendingWithdrawAmountData, setPendingWithdrawAmountData] =
    React.useState([]);
  const [KYCPending, setKYCPendingr] = React.useState();

  useEffect(() => {
    getPlayerList();
  }, []);

  const getPlayerList = async () => {
    try {
      const config = { method: "GET", credentials: "include" };
      const [
        playerRes,
        betRes,
        winRes,
        withdrawRes,
        pendingWithdrawRes,
        kycRes,
      ] = await Promise.all([
        axios(`${API_URL}/api/admin/dashboard/dashboard-total-player`, config),
        axios(`${API_URL}/api/admin/dashboard/dashboard-total-bet-amount`, config),
        axios(`${API_URL}/api/admin/dashboard/dashboard-total-win-amount`, config),
        axios(`${API_URL}/api/admin/dashboard/dashboard-total-withdraw-amount`, config),
        axios(`${API_URL}/api/admin/dashboard/dashboard-total-pending-withdraw-amount`, config),
        axios(`${API_URL}/api/admin/dashboard/get-all-kyc-pending`, config),
      ]);

      setTotalPlayerData(playerRes.data.data);
      setTotalBetAmountData(betRes.data.data);
      setTotalWinAmountData(winRes.data.data);
      setTotalWithdrawAmountData(withdrawRes.data.data);
      setPendingWithdrawAmountData(pendingWithdrawRes.data.data);
      setKYCPendingr(kycRes.data.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  const formatNumber = (value) => {
    let num = Number(value);
    if (isNaN(num)) return "0";

    const UNITS = ["", "K", "M", "B", "T", "Q"];
    let index = 0;

    while (num >= 1000 && index < UNITS.length - 1) {
      num /= 1000;
      index++;
    }

    return num.toFixed(1) + UNITS[index];
  };

  return (
    <div>
      <div className="content-header"></div>
      {accessObject?.dashboardCount == true ? (
        <>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-3 col-6">
                  <StatCard
                    title="Total Player"
                    value={
                      <CountUp
                        end={totalPlayerData}
                        duration={2}
                        formattingFn={formatNumber}
                      />
                    }
                    icon={totalPlayer}
                    trend="+12%"
                    iconClass="icon-orange"
                    onClick={() => history("/playerlist", { state: { data: false } })}
                  />
                </div>
                <div className="col-lg-3 col-6">
                  <StatCard
                    title="Total Withdraw"
                    value={
                      <CountUp
                        end={totalWithdrawAmountData}
                        duration={2}
                        formattingFn={formatNumber}
                      />
                    }
                    icon={total_withdraw_icon}
                    trend="+5%"
                    iconClass="icon-purple"
                    onClick={() => history("/payout", { state: { data: "All" } })}
                  />
                </div>
                <div className="col-lg-3 col-6">
                  <StatCard
                    title="Pending Withdraw"
                    value={
                      <CountUp
                        end={pendingWithdrawAmountData}
                        duration={2}
                        formattingFn={formatNumber}
                      />
                    }
                    icon={total_withdraw_icon}
                    trend="+10%"
                    iconClass="icon-blue"
                    onClick={() => history("/payout", { state: { data: true } })}
                  />
                </div>
                <div className="col-lg-3 col-6">
                  <StatCard
                    title="Total Bet"
                    value={
                      <CountUp
                        end={totalBetAmountData}
                        duration={2}
                        formattingFn={formatNumber}
                      />
                    }
                    icon={total_bet_amount_icon}
                    trend="+8%"
                    iconClass="icon-emerald"
                    onClick={() => history("/bet")}
                  />
                </div>
                <div className="col-lg-3 col-6">
                  <StatCard
                    title="Total Win"
                    value={
                      <CountUp
                        end={totalWinAmountData}
                        duration={2}
                        formattingFn={formatNumber}
                      />
                    }
                    icon={total_win_amount_icon}
                    trend="+6%"
                    iconClass="icon-red"
                    onClick={() => history("/win")}
                  />
                </div>
                <div className="col-lg-3 col-6">
                  <StatCard
                    title="KYC Pending"
                    value={
                      <CountUp
                        end={KYCPending}
                        duration={2}
                        formattingFn={formatNumber}
                      />
                    }
                    icon={total_income_icon}
                    trend="+2%"
                    iconClass="icon-purple"
                    onClick={() => history("/playerlist", { state: { data: true } })}
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <>
          <table className="w-100">
            <tbody>
              <tr style={{ background: "gray" }}>
                <td className="p-3">
                  <h5 className="text-center mb-0 text-light">Access Denied</h5>
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
